module.exports = __webpack_public_path__ + "media/MRI4.040d4be5.mp3";